export default __webpack_public_path__ + "static/media/FAC3.56985555.jpg";